import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { NoPictureIcon } from "../../../data/iconImage";
import { filteredItemByArray } from "../../../utils/ManageArray";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { FloatingControlComponent } from "../../../components/FormComponent";
import SearchFilter from "../../../components/SearchFilter";
import ItemsService from "../../../services/item.service";
import ContentModal from "../../../components/ContentModal";
import CardDisplayComponent from "../../../components/CardDisplayComponent";

export default function ProductInformation() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(null);
  const [show, setShow] = useState(false);
  const searchInput = [
    {
      name: "Item_Code",
      label: "รหัสสินค้า",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: ItemsService.getAllItems(query),
          callback: ({ items }) => setData(items)
        })
    },
    {
      name: "Item_Name_TH",
      label: "ชื่อสินค้า",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: ItemsService.getAllItems(query),
          callback: ({ items }) => setData(items)
        })
    }
  ];
  const infoField = [
    { name: "Item_Code", label: "รหัสสินค้า", size: 12 },
    { name: "Item_Name_TH", label: "ชื่อสินค้า (ไทย)", size: 12 },
    { name: "Item_Name_EN", label: "ชื่อสินค้า (อังกฤษ)", size: 12 },
    { name: "Item_Group", label: "กลุ่มสินค้า" },
    { name: "Item_Brand", label: "แบรนด์" },
    { name: "Item_Model", label: "รุ่น" },
    { name: "Item_PartNo", label: "Part No" },
    { name: "Item_SupWarranty", label: "Sup Warranty" },
    { name: "Item_FvcWarranty", label: "FVC Warranty" },
    { name: "Item_Status", label: "สถานะ" }
  ];

  return (
    <>
      <Helmet>
        <title>ข้อมูลสินค้า</title>
        <meta name="description" content="Product Information Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={data}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) =>
                  setFilteredData(
                    search.some(({ value }) => value)
                      ? filteredItemByArray(data, search)[0]
                      : null
                  )
                }
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            element: (
              <>
                <Col sm={6} className="me-5 mb-0">
                  <Card.Header className="mb-4 p-0 pb-2 bg-transparent">
                    <Card.Title className="fs-2">ข้อมูลสินค้า</Card.Title>
                  </Card.Header>

                  <Card.Body as={Row} className="p-0">
                    {infoField.map(({ name, label, size }, idx) => (
                      <Col
                        key={idx}
                        sm={size || 6}
                        className={`mt-1 ${idx !== 9 ? "mb-3" : ""} fs-4`}
                      >
                        <FloatingControlComponent
                          readOnly
                          type="text"
                          name={name}
                          label={label}
                          value={
                            filteredData && name === "Item_Status"
                              ? filteredData?.[name]
                                ? "ใช้งาน"
                                : "ไม่ใช้งาน"
                              : filteredData?.[name] || "-"
                          }
                        />
                      </Col>
                    ))}
                  </Card.Body>

                  <Card.Footer className="mt-3 px-0 bg-transparent border-top-0">
                    <Button
                      variant="success"
                      className="px-5 pt-2 text-dark rounded-pill"
                    >
                      อัพโหลดข้อมูล
                    </Button>
                  </Card.Footer>
                </Col>

                <Col sm={5} className="ms-4 ps-5 pb-5 d-flex flex-column">
                  <Card.Header className="mb-4 p-0 pb-2 bg-transparent border-bottom-0">
                    <Card.Title className="fs-2 text-center">
                      รูปสินค้า
                    </Card.Title>
                  </Card.Header>

                  <Card.Body className="ms-1 p-5 pt-0 text-center flex-grow-1">
                    <Col className="w-100 h-100 mb-3 d-flex flex-column justify-content-center align-items-center border border-secondary">
                      <Card.Img
                        className={filteredData?.Item_Pic ? "w-100" : "w-10"}
                        src={
                          filteredData?.Item_Pic
                            ? `${process.env.REACT_APP_STORAGE_URL}/technician-picture/${filteredData?.Item_Pic}`
                            : NoPictureIcon
                        }
                        alt={filteredData?.Item_Pic || "No Picture Icon"}
                      />
                      {!filteredData?.Item_Pic && (
                        <Card.Text className="mt-3 fs-4 text-secondary">
                          ไม่มีรูปภาพ
                        </Card.Text>
                      )}
                    </Col>

                    {!filteredData?.Item_Pic && (
                      <>
                        <Col>
                          <Button
                            variant="outline-success"
                            className="px-4 py-2 text-dark border-secondary rounded-pill"
                            onClick={() => setShow(!show)}
                          >
                            ดูภาพใหญ่
                          </Button>
                        </Col>
                        <ContentModal
                          show={show}
                          size="xl"
                          body={
                            <Card.Img
                              height="100%"
                              src={`${process.env.REACT_APP_STORAGE_URL}/technician-picture/${filteredData?.Item_Pic}`}
                              alt={filteredData?.Item_Pic}
                            />
                          }
                          footer={
                            <Button
                              variant="outline-secondary"
                              className="px-5 py-2 text-dark rounded-pill"
                              onClick={() => setShow(!show)}
                            >
                              ยกเลิก
                            </Button>
                          }
                        />
                      </>
                    )}
                  </Card.Body>
                </Col>
              </>
            )
          }}
        />
      </Container>
    </>
  );
}
